import React, { useState, useEffect } from 'react';
import Checkbox1 from '../../../images/uielements/checkbox/animated-checkbox.gif';
import Checkbox2 from '../../../images/uielements/checkbox/ChoiceBox.gif';
import CheckboxFile1 from '../../Files/CheckBox/animated-checkbox.zip'
import CheckboxFile2 from '../../Files/CheckBox/choicebox.zip'
import { LuDownload } from "react-icons/lu";
import './checkboxlist.scss'

const CheckBoxList = () => {

    const [CheckboxData, setCheckboxData] = useState([]);

    const getAllCheckboxData = async () => {
        try {
            const response = await fetch('/data/uielements.json');
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();

            const filterCheckboxData = data.UIElements?.filter((uicode) => uicode.UIElementId === "UIElemetCheckbox")

            setCheckboxData(filterCheckboxData || []);
        } catch (err) {
            console.error('Error fetching checkbox data:', err);
        }
    }

    useEffect(() => {
        getAllCheckboxData();
    }, [])

    const handleDownload = (file) => {
        const link = document.createElement('a');
        link.href = file;
        link.download = file.split('/').pop(); // Extract file name from path
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="mainCheckBoxList">
            <div className="subCheckBoxList">
                {
                    CheckboxData.length === 0 ? (
                        <p>No Data</p>
                    ) : (
                        CheckboxData.map((item, index) => (
                            <div className="CheckBoxList">
                                <div className="CheckBoxListInfo">
                                    <div className="CheckBoxListUIElements-image-box">
                                        <img src={item.VideoGif} alt="" />
                                        <p>{item.developer}</p>
                                    </div>
                                </div>
                                <div className="CheckBoxListInfo">
                                    <button className='DownloadBtn' onClick={() => handleDownload(item.DownloadCode)}>Download</button>
                                </div>
                            </div>
                        )))
                }
            </div>
        </div>
    )
}

export default CheckBoxList